import { DataTypes, DataVariants, DataCardinalities } from "../../../data/DataManager";
import { GridRenderSlots } from "../../../grid/AgGridManager";
import { InputTypes, Widths } from "../../../form/FormManager";
import { FieldSchema } from "../../../Schema";
import { Tag } from "../../common/external-sources/Tags";
import { SchemaContext } from "../../common";

export const createTags = (context: SchemaContext): FieldSchema => ({
  name: "tags",
  grid: {
    displayed: true,
    order: 54,
    render: GridRenderSlots.TAGS,
    sortable: false,
  },
  data: {
    type: DataTypes.ARRAY,
    variant: DataVariants.ENUM,
    options: context.tags.map((tag: Tag) => ({ value: tag.filterValue, label: tag.filterValue })),
    cardinality: DataCardinalities.MULTIPLE,
    maxCount: 10,
  },
  display: {
    displayed: true,
  },
  form: {
    label: "Tags",
    type: InputTypes.MULTISELECT,
    helperText: "You can add/select maximum of 10 tags",
    width: Widths.DOUBLE,
  },
});
